<script>
import ProductVariantAttributesMixin from '../mixins/product-variant-attributes';
import UserMixin from '../../../mixins/user';
import CompareListTableCartVariantRow from './CompareListTableCartVariantRow.vue';

export default {
  name: 'CompareListTableCartCell',
  mixins: [UserMixin, ProductVariantAttributesMixin],
  components: { CompareListTableCartVariantRow },
  props: ['product'],
};
</script>

<template>
  <td class="pb-2 align-top space-y-4">
    <div v-for="format in optionFormats" :key="format" class="flex flex-col">
      <div class="bg-light-blue-900 text-white px-3 py-1">{{ format }}</div>
      <table class="w-full">
        <thead>
          <tr class="bg-gray-diagomics-light">
            <th class="w-2/12 text-left">{{ $t('presentation_ab') }}</th>
            <th class="w-3/12 text-left">{{ $t('reference_ab') }}</th>
            <th class="w-24"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            is="CompareListTableCartVariantRow"
            v-for="variant in getSortedVariantsByFormat(format)"
            :key="variant.id"
            :variant="variant"
            class="even:bg-gray-diagomics-light"
          ></tr>
        </tbody>
      </table>
    </div>
  </td>
</template>
